"use strict";
/**
 * Validation Error Messages
 *
 * Central location for all validation error messages used across the loan application.
 * This ensures consistency and makes it easier to update messages.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_MESSAGES = exports.GENERIC_ERRORS = exports.AGREEMENTS_ERRORS = exports.ELECTRONIC_PAYMENTS_ERRORS = exports.SALARY_DEDUCTION_ERRORS = exports.DOCUMENTS_ERRORS = exports.FINANCIAL_ERRORS = exports.BANKING_ERRORS = exports.HR_DETAILS_ERRORS = exports.EMPLOYMENT_ERRORS = exports.FAMILY_FRIEND_ERRORS = exports.PERSONAL_DETAILS_ERRORS = exports.LOAN_SETUP_ERRORS = void 0;
// Step 0: Loan Setup
exports.LOAN_SETUP_ERRORS = {
    PROVIDER_REQUIRED: "Please select a loan provider",
    BRANCH_REQUIRED: "Please select a branch",
    LOAN_TERM_REQUIRED: "Please select loan term",
    LOAN_AMOUNT_REQUIRED: "Please enter a valid loan amount",
    LOAN_AMOUNT_MIN: function (min) { return "Minimum loan amount is ".concat(min); },
    LOAN_AMOUNT_MAX: function (max) { return "Maximum loan amount is ".concat(max); },
};
// Step 1: KYC - No validation messages (handled by FaceTec component)
// Step 2: Personal Details
exports.PERSONAL_DETAILS_ERRORS = {
    NAME_REQUIRED: "Please enter your name",
    SURNAME_REQUIRED: "Please enter your surname",
    ID_NUMBER_REQUIRED: "Please enter your ID number",
    ID_NUMBER_INVALID: "Please enter a valid ID number",
    GENDER_REQUIRED: "Please select your gender",
    MARITAL_STATUS_REQUIRED: "Please select your marital status",
    MARRIAGE_TYPE_REQUIRED: "Please select your marriage type",
    EMAIL_REQUIRED: "Please enter your email address",
    EMAIL_INVALID: "Please enter a valid email address",
    CELL_NUMBER_REQUIRED: "Please enter your cell number",
    CELL_NUMBER_INVALID: function (fieldName) {
        return "".concat(fieldName, " must be exactly 9 digits");
    },
    HOME_ADDRESS_REQUIRED: "Please enter your home address",
};
// Step 3: Family & Friend Contacts
exports.FAMILY_FRIEND_ERRORS = {
    FAMILY_NAME_REQUIRED: "Please enter family member name",
    FAMILY_SURNAME_REQUIRED: "Please enter family member surname",
    FAMILY_RELATIONSHIP_REQUIRED: "Please select relationship",
    FAMILY_CELL_REQUIRED: "Please enter family member cell number",
    FRIEND_NAME_REQUIRED: "Please enter friend name",
    FRIEND_SURNAME_REQUIRED: "Please enter friend surname",
    FRIEND_CELL_REQUIRED: "Please enter friend cell number",
};
// Step 4: Employment Details
exports.EMPLOYMENT_ERRORS = {
    STATUS_REQUIRED: "Please select employment status",
    MONTHLY_INCOME_REQUIRED: "Please enter your monthly income",
    MONTHLY_INCOME_INVALID: "Please enter a valid number (max 2 decimal places)",
    MONTHLY_INCOME_POSITIVE: "Monthly income must be greater than 0",
    EMPLOYER_REQUIRED: "Please enter your employer",
    SUPERVISOR_REQUIRED: "Please enter supervisor name",
    WORK_NUMBER_REQUIRED: "Please enter work number",
    WORK_NUMBER_INVALID: function (fieldName) {
        return "".concat(fieldName, " must be exactly 9 digits");
    },
    WORKPLACE_ADDRESS_REQUIRED: "Please enter workplace address",
    APPOINTMENT_DATE_REQUIRED: "Please select your start date",
};
// Step 5: HR Details (Paymaster/Paypoint)
exports.HR_DETAILS_ERRORS = {
    PAYMASTER_NAME_REQUIRED: "Please enter paymaster name",
    PAYPOINT_PHONE_REQUIRED: "Please enter pay point phone number",
    PAYPOINT_PHONE_INVALID: function (fieldName) {
        return "".concat(fieldName, " must be exactly 9 digits");
    },
    PAYPOINT_PHYSICAL_ADDRESS_REQUIRED: "Please enter pay point physical address",
    PAY_DATE_REQUIRED: "Please select your pay date",
    // HR Contact Details (Required)
    HR_NAME_REQUIRED: "HR name is required",
    HR_PHONE_REQUIRED: "HR phone number is required",
    HR_PHONE_INVALID: function (fieldName) {
        return "".concat(fieldName, " must be exactly 9 digits");
    },
    HR_POSTAL_ADDRESS_REQUIRED: "HR postal address is required",
    HR_POSTAL_CODE_REQUIRED: "Postal code is required",
    HR_PHYSICAL_ADDRESS_REQUIRED: "HR physical address is required",
};
// Step 6: Salary Banking Details
exports.BANKING_ERRORS = {
    BANK_REQUIRED: "Please select a bank",
    BANK_BRANCH_REQUIRED: "Please enter bank branch",
    ACCOUNT_NUMBER_REQUIRED: "Please enter account number",
    ACCOUNT_NUMBER_NUMERIC: "Account number must contain only numbers",
    ACCOUNT_TYPE_REQUIRED: "Please select account type",
};
// Step 7: Financial Details
exports.FINANCIAL_ERRORS = {
    HOUSING_EXPENSE_REQUIRED: "Please enter a valid housing expense",
    HOUSING_EXPENSE_INVALID: "Please enter a valid amount (max 2 decimal places)",
    TRANSPORT_EXPENSE_REQUIRED: "Please enter a valid transport expense",
    TRANSPORT_EXPENSE_INVALID: "Please enter a valid amount (max 2 decimal places)",
    EDUCATION_EXPENSE_REQUIRED: "Please enter a valid education expense",
    EDUCATION_EXPENSE_INVALID: "Please enter a valid amount (max 2 decimal places)",
    ELECTRICITY_EXPENSE_REQUIRED: "Please enter a valid electricity expense",
    ELECTRICITY_EXPENSE_INVALID: "Please enter a valid amount (max 2 decimal places)",
    GROCERIES_EXPENSE_REQUIRED: "Please enter a valid groceries expense",
    GROCERIES_EXPENSE_INVALID: "Please enter a valid amount (max 2 decimal places)",
    ACCOUNT_PAYMENT_DESC_REQUIRED: "Please enter account payment description",
    ACCOUNT_PAYMENT_AMT_REQUIRED: "Please enter valid amount",
    ACCOUNT_PAYMENT_AMT_INVALID: "Invalid amount (max 2 decimals)",
    DEDUCTION_DESC_REQUIRED: "Please enter deduction description",
    DEDUCTION_AMT_REQUIRED: "Please enter valid amount",
    DEDUCTION_AMT_INVALID: "Invalid amount (max 2 decimals)",
    OBLIGATION_DESC_REQUIRED: "Please enter obligation description",
    OBLIGATION_AMT_REQUIRED: "Please enter valid amount",
    OBLIGATION_AMT_INVALID: "Invalid amount (max 2 decimals)",
    PAY_FREQUENCY_REQUIRED: "Please select pay frequency",
    PAY_DATE_REQUIRED: "Please enter pay day",
    PAY_DATE_INVALID: "Pay day must be a number",
    PAY_DATE_RANGE: "Pay day must be between 1 and 31",
};
// Step 8: Required Documents
exports.DOCUMENTS_ERRORS = {
    PAYSLIP_REQUIRED: "Please upload your latest payslip",
    BANK_STATEMENTS_REQUIRED: "Please upload your bank statements (last 3 months)",
    AT_LEAST_ONE_REQUIRED: "Please upload at least one document (payslip or bank statement)",
};
// Step 9: Authorization for Salary Deduction
exports.SALARY_DEDUCTION_ERRORS = {
    LENDER_REQUIRED: "Please enter lender name",
    EMPLOYER_REQUIRED: "Please enter your employer name",
    SIGNATURE_REQUIRED: "Please provide your digital signature",
};
// Step 10: Authorization for Electronic Payments (Bank Debit)
exports.ELECTRONIC_PAYMENTS_ERRORS = {
    BANK_SIGNATURE_REQUIRED: "Please provide bank debit authorization signature",
    CONFIRMATION_REQUIRED: "Please confirm that all information provided is accurate and complete",
};
// Combined Agreements (Steps 9 & 10)
exports.AGREEMENTS_ERRORS = __assign(__assign({}, exports.SALARY_DEDUCTION_ERRORS), exports.ELECTRONIC_PAYMENTS_ERRORS);
// Generic validation messages
exports.GENERIC_ERRORS = {
    REQUIRED_FIELD: "This field is required",
    INVALID_INPUT: "Please enter a valid value",
    NUMERIC_ONLY: "This field must contain only numbers",
    POSITIVE_NUMBER: "This field must be a positive number",
    VALID_DECIMAL: function (decimals) {
        return "Please enter a valid number (max ".concat(decimals, " decimal places)");
    },
};
// Form-level messages
exports.FORM_MESSAGES = {
    COMPLETE_REQUIRED_FIELDS: "Please complete all required fields before continuing.",
    VALIDATION_FAILED: "Please check the form for errors and try again.",
    SAVE_SUCCESS: "Your progress has been saved successfully.",
    SAVE_ERROR: "Failed to save your progress. Please try again.",
    SUBMIT_SUCCESS: "Your loan application has been submitted successfully!",
    SUBMIT_ERROR: "Failed to submit your application. Please try again.",
};
